// components/Common/LoadingSquare.jsx
import React from "react";
import "./LoadingSquare.css";

const LoadingSquare = ({ color = "#fff", isLoaded=false }) => {
  return (
    <div
      className={`loading-square ${isLoaded ? "loaded" : ""}`}
      style={{ backgroundColor: color }}
    />
  );
};

export default LoadingSquare;
